import { CheckoutResponse } from '../services/models';
import { Classification } from '../services/models/Classification';
import { checkoutFulfillmentOptions } from '../types';

export const CheckoutRoutePaths = 'checkout';

export const isProxyOrder = (data: CheckoutResponse) => data?.classifications?.includes(Classification.Proxy) || false;

export const isDigitalFlow = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Digital) || false;

export const isDigitalServiceFlow = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Digital) ||
  data?.classifications?.includes(Classification.Service) ||
  false;

export const isGroupOrder = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Gco) || false;

export const isProxyNotGroupOrder = (data: CheckoutResponse) =>
  (data?.classifications?.includes(Classification.Proxy) && !data?.classifications?.includes(Classification.Gco)) ||
  false;

export const isRenewalOrder = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Renewal) || false;

export const isRegistrationOrder = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Registration) || false;

export const isUpgradeOrder = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Upgrade) || false;

export const isDowngradeOrder = (data?: CheckoutResponse | null) =>
  data?.classifications?.includes(Classification.Downgrade) || false;

export const isSelfAddress = (data: CheckoutResponse) => {
  let selfAddressUpdate = false;
  if (data?.fulfillment?.address?.ownerId == data?.user?.id) {
    selfAddressUpdate = true;
  }
  if (selfAddressUpdate && !isProxyOrder(data)) {
    return true;
  } else {
    return false;
  }
};
export const needToUpdateCheckoutProfile = (data: CheckoutResponse): boolean =>
  data?.fulfillment?.id != checkoutFulfillmentOptions.HOMEDELIVERY;
